import type { ColumnsCount } from '@/types/masonry';

export const GRID_ID = 'full-grid';
export const SECTION_GRID_ID = 'masonry-grid';
export const VERTICAL_GAP = 10;
export const MAX_HEIGHT = 700;
export const HORIZONTAL_GAP = 10;

export const DEFAULT_COLUMNS_COUNT: ColumnsCount = {
  Small: 2,
  Medium: 2,
  Large: 3,
  ExtraLarge: 4,
  UltraLarge: 5,
  FullHD: 5,
  XXL: 7,
};

export const CATEGORY_PAGE_COLUMNS: ColumnsCount = {
  Small: 2,
  Medium: 2,
  Large: 3,
  ExtraLarge: 3,
  UltraLarge: 4,
  FullHD: 4,
  XXL: 5,
};
